<div class="optimization-animation-dialog">
  <img src="assets/in-progress-optimization/optimizing.gif" alt="Optimization in progress" class="optimization-animation">
  <button class="down-arrow-button" (click)="dialogRef.close()">
    <img src="assets/booking-engine/icons/down-arrow-icon.png" alt="Close" class="down-arrow-icon">
  </button>
</div>

